import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info jhi-item-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, "显示第 " + _toDisplayString(_ctx.first) + " - " + _toDisplayString(_ctx.second) + " 条，共 " + _toDisplayString(_ctx.total) + " 条", 1 /* TEXT */)
  ]))
}